import React from 'react';
import './article.css';

const Article = ({ imgUrl, text, url, btnText, icon }) => {
  return (
    <div className="article">
      <div className="article__image-container">
        <div className="article__image-overlay"></div>
        {imgUrl && <img src={imgUrl} alt="" className="article__image" />}
        
        {icon && (
          <div className="article__icon">
            {icon}
          </div>
        )}
      </div>
      
      <div className="article__content">
        <p className="article__text">{text}</p>
        <a href={url} className="article__button">
          {btnText}
        </a>
      </div>
    </div>
  );
};

export default Article;